import * as Sentry from '@sentry/react'

const APP_VERSION = import.meta.env.VITE_SENTRY_RELEASE || __APP_VERSION__

export function initSentry(dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE, // 'development' or 'production'
    release: APP_VERSION,
    tracesSampleRate: 1.0,
    // Capture 100% of errors, 10% of normal transactions
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    // Send user data for better debugging context
    sendDefaultPii: true,
  })
}
